// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List, Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetSpotApiV33MarketSummary (params?: {}): Promise<List>;
    publicGetSpotApiV33Ohlcv (params?: {}): Promise<List>;
    publicGetSpotApiV33Price (params?: {}): Promise<Dict | List>;
    publicGetSpotApiV33Orderbook (params?: {}): Promise<Dict | List>;
    publicGetSpotApiV33OrderbookL2 (params?: {}): Promise<Dict | List>;
    publicGetSpotApiV33Trades (params?: {}): Promise<List>;
    publicGetSpotApiV33Time (params?: {}): Promise<Dict | List>;
    publicGetFuturesApiV23MarketSummary (params?: {}): Promise<List>;
    publicGetFuturesApiV23Ohlcv (params?: {}): Promise<List>;
    publicGetFuturesApiV23Price (params?: {}): Promise<Dict | List>;
    publicGetFuturesApiV23Orderbook (params?: {}): Promise<Dict | List>;
    publicGetFuturesApiV23OrderbookL2 (params?: {}): Promise<Dict | List>;
    publicGetFuturesApiV23Trades (params?: {}): Promise<List>;
    publicGetFuturesApiV23FundingHistory (params?: {}): Promise<Dict | List>;
    publicGetFuturesApiV23MarketRiskLimit (params?: {}): Promise<Dict | List>;
    publicGetSpotApiV32AvailableCurrencyNetworks (params?: {}): Promise<Dict | List>;
    publicGetSpotApiV32ExchangeRate (params?: {}): Promise<Dict | List>;
    publicGetPublicApiWalletV1CryptoNetworks (params?: {}): Promise<Dict | List>;
    publicGetPublicApiWalletV1AssetsExchangeRate (params?: {}): Promise<Dict | List>;
    publicGetPublicApiMarketV1Markets (params?: {}): Promise<Dict>;
    publicGetPublicApiMarketV1ExchangeInfo (params?: {}): Promise<Dict | List>;
    publicGetPublicApiMarketV1Orderbook (params?: {}): Promise<Dict>;
    publicGetPublicApiMarketV1Trades (params?: {}): Promise<Dict>;
    publicGetPublicApiMarketV1Klines (params?: {}): Promise<Dict>;
    publicGetPublicApiMarketV1Ticker24hr (params?: {}): Promise<Dict>;
    publicGetPublicApiMarketV1TickerPrice (params?: {}): Promise<Dict | List>;
    publicGetPublicApiMarketV1TickerIndices (params?: {}): Promise<Dict | List>;
    publicGetPublicApiMarketV1TickerL1 (params?: {}): Promise<Dict | List>;
    publicGetPublicApiMarketV1RecentFundingHistory (params?: {}): Promise<Dict>;
    publicGetPublicApiMarketV1RiskLimits (params?: {}): Promise<Dict>;
    publicGetPublicApiWalletV1CryptoList (params?: {}): Promise<Dict | List>;
    publicGetPublicApiOtcV1Markets (params?: {}): Promise<Dict | List>;
    privateGetSpotApiV33Order (params?: {}): Promise<Dict | List>;
    privateGetSpotApiV33UserOpenOrders (params?: {}): Promise<Dict | List>;
    privateGetSpotApiV33UserTradeHistory (params?: {}): Promise<List>;
    privateGetSpotApiV33UserFees (params?: {}): Promise<List>;
    privateGetSpotApiV33InvestProducts (params?: {}): Promise<Dict | List>;
    privateGetSpotApiV33InvestOrders (params?: {}): Promise<Dict | List>;
    privateGetSpotApiV33InvestHistory (params?: {}): Promise<Dict | List>;
    privateGetFuturesApiV23Order (params?: {}): Promise<Dict | List>;
    privateGetFuturesApiV23UserOpenOrders (params?: {}): Promise<Dict | List>;
    privateGetFuturesApiV23UserTradeHistory (params?: {}): Promise<List>;
    privateGetFuturesApiV23UserPositions (params?: {}): Promise<List>;
    privateGetFuturesApiV23RiskLimit (params?: {}): Promise<Dict | List>;
    privateGetFuturesApiV23Leverage (params?: {}): Promise<Dict | List>;
    privateGetFuturesApiV23UserFees (params?: {}): Promise<List>;
    privateGetFuturesApiV23PositionMode (params?: {}): Promise<List>;
    privateGetFuturesApiV23UserMarginSetting (params?: {}): Promise<Dict | List>;
    privateGetFuturesApiV23UserWallet (params?: {}): Promise<List>;
    privateGetFuturesApiV23UserWalletHistory (params?: {}): Promise<Dict | List>;
    privateGetFuturesApiV23UserUnifiedWalletMargin (params?: {}): Promise<Dict | List>;
    privateGetFuturesApiV23UserMargin (params?: {}): Promise<Dict | List>;
    privateGetOtcApiV1GetMarket (params?: {}): Promise<Dict | List>;
    privateGetSpotApiV32UserWallet (params?: {}): Promise<List>;
    privateGetSpotApiV32UserWalletHistory (params?: {}): Promise<List>;
    privateGetSpotApiV33UserWalletAddress (params?: {}): Promise<Dict | List>;
    privateGetSpotApiV32AvailableCurrencies (params?: {}): Promise<Dict | List>;
    privateGetSpotApiV32SubaccountWalletHistory (params?: {}): Promise<Dict | List>;
    privateGetSpotApiV4TradeOrders (params?: {}): Promise<List>;
    privateGetSpotApiV4TradeOrder (params?: {}): Promise<Dict>;
    privateGetSpotApiV4TradeTradeHistory (params?: {}): Promise<Dict | List>;
    privateGetSpotApiV4TradeFees (params?: {}): Promise<List>;
    privateGetFuturesApiV3TradeOrders (params?: {}): Promise<List>;
    privateGetFuturesApiV3TradeRiskLimit (params?: {}): Promise<Dict | List>;
    privateGetFuturesApiV3TradePositionMode (params?: {}): Promise<List>;
    privateGetFuturesApiV3TradeLeverage (params?: {}): Promise<List>;
    privateGetFuturesApiV3TradeTradeHistory (params?: {}): Promise<List>;
    privateGetFuturesApiV3TradePositions (params?: {}): Promise<List>;
    privateGetFuturesApiV3TradeMarginSetting (params?: {}): Promise<Dict | List>;
    privateGetPublicApiWalletV1Assets (params?: {}): Promise<Dict | List>;
    privateGetPublicApiWalletV1UserAssets (params?: {}): Promise<Dict>;
    privateGetPublicApiWalletV1UserWalletHistory (params?: {}): Promise<Dict | List>;
    privateGetPublicApiWalletV1UserCryptoAddress (params?: {}): Promise<Dict | List>;
    privateGetPublicApiOtcV1Quotes (params?: {}): Promise<Dict | List>;
    privatePostSpotApiV33Order (params?: {}): Promise<Dict | List>;
    privatePostSpotApiV33OrderPeg (params?: {}): Promise<Dict | List>;
    privatePostSpotApiV33OrderCancelAllAfter (params?: {}): Promise<Dict>;
    privatePostSpotApiV33InvestDeposit (params?: {}): Promise<Dict | List>;
    privatePostSpotApiV33InvestRenew (params?: {}): Promise<Dict | List>;
    privatePostSpotApiV33InvestRedeem (params?: {}): Promise<Dict | List>;
    privatePostFuturesApiV23Order (params?: {}): Promise<Dict | List>;
    privatePostFuturesApiV23OrderPeg (params?: {}): Promise<Dict | List>;
    privatePostFuturesApiV23OrderCancelAllAfter (params?: {}): Promise<Dict>;
    privatePostFuturesApiV23OrderClosePosition (params?: {}): Promise<Dict | List>;
    privatePostFuturesApiV23RiskLimit (params?: {}): Promise<Dict | List>;
    privatePostFuturesApiV23Leverage (params?: {}): Promise<Dict | List>;
    privatePostFuturesApiV23SettleIn (params?: {}): Promise<Dict | List>;
    privatePostFuturesApiV23OrderBindTpsl (params?: {}): Promise<Dict | List>;
    privatePostFuturesApiV23PositionMode (params?: {}): Promise<Dict>;
    privatePostFuturesApiV23UserWalletTransfer (params?: {}): Promise<Dict | List>;
    privatePostFuturesApiV23SubaccountWalletTransfer (params?: {}): Promise<Dict | List>;
    privatePostOtcApiV1Quote (params?: {}): Promise<Dict | List>;
    privatePostOtcApiV1AcceptQuoteId (params?: {}): Promise<Dict | List>;
    privatePostOtcApiV1RejectQuoteId (params?: {}): Promise<Dict | List>;
    privatePostOtcApiV1QueryOrderQuoteId (params?: {}): Promise<Dict | List>;
    privatePostSpotApiV33UserWalletAddress (params?: {}): Promise<Dict | List>;
    privatePostSpotApiV33UserWalletWithdraw (params?: {}): Promise<Dict | List>;
    privatePostSpotApiV32UserWalletConvert (params?: {}): Promise<Dict | List>;
    privatePostSpotApiV33UserWalletTransfer (params?: {}): Promise<Dict | List>;
    privatePostSpotApiV4TradeOrders (params?: {}): Promise<List>;
    privatePostSpotApiV4TradeOrdersCancelAllAfter (params?: {}): Promise<Dict>;
    privatePostSpotApiV4TradeOrdersAlgo (params?: {}): Promise<List>;
    privatePostFuturesApiV3TradeOrders (params?: {}): Promise<Dict>;
    privatePostFuturesApiV3TradeOrdersCancelAllAfter (params?: {}): Promise<Dict>;
    privatePostFuturesApiV3TradeOrdersAlgo (params?: {}): Promise<Dict>;
    privatePostFuturesApiV3TradeSettleIn (params?: {}): Promise<Dict | List>;
    privatePostFuturesApiV3TradeRiskLimit (params?: {}): Promise<Dict | List>;
    privatePostFuturesApiV3TradePositionsTpsl (params?: {}): Promise<Dict | List>;
    privatePostFuturesApiV3TradePositionMode (params?: {}): Promise<Dict>;
    privatePostFuturesApiV3TradeLeverage (params?: {}): Promise<Dict>;
    privatePostPublicApiWalletV1UserCryptoAddress (params?: {}): Promise<Dict | List>;
    privatePostPublicApiWalletV1UserCryptoWithdraw (params?: {}): Promise<Dict | List>;
    privatePostPublicApiWalletV1UserAssetsSendTo (params?: {}): Promise<Dict | List>;
    privatePostPublicApiWalletV1UserAssetsConvert (params?: {}): Promise<Dict | List>;
    privatePostPublicApiOtcV1Quotes (params?: {}): Promise<Dict | List>;
    privatePostPublicApiOtcV1QuotesAccept (params?: {}): Promise<Dict | List>;
    privatePutSpotApiV33Order (params?: {}): Promise<Dict | List>;
    privatePutFuturesApiV23Order (params?: {}): Promise<Dict | List>;
    privatePutSpotApiV4TradeOrders (params?: {}): Promise<List>;
    privatePutFuturesApiV3TradeOrders (params?: {}): Promise<List>;
    privateDeleteSpotApiV33Order (params?: {}): Promise<Dict | List>;
    privateDeleteFuturesApiV23Order (params?: {}): Promise<Dict | List>;
    privateDeleteSpotApiV33UserWalletAddress (params?: {}): Promise<Dict | List>;
    privateDeleteSpotApiV4TradeOrders (params?: {}): Promise<List>;
    privateDeleteSpotApiV4TradeOrdersAll (params?: {}): Promise<List>;
    privateDeleteFuturesApiV3TradeOrders (params?: {}): Promise<List>;
    privateDeleteFuturesApiV3TradePositions (params?: {}): Promise<Dict | List>;
    privateDeletePublicApiWalletV1UserCryptoAddress (params?: {}): Promise<Dict | List>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
